module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "templatedefault"
  }, [(_vm.homeslogan) ? _c('div', {
    staticClass: "slogan",
    style: ({
      color: _vm.homeslogancolor
    })
  }, [_vm._v(_vm._s(_vm.homeslogan))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-inner",
    staticStyle: {
      "padding-top": "20px",
      "margin": "0 30px 30px 30px"
    },
    attrs: {
      "flex": "dir:left box:last"
    }
  }, [_c('div', {
    staticClass: "sidebar_a"
  }, [_c('div', {
    staticClass: "main"
  }, _vm._l((_vm.zbxxList), function(zbxxclass, index) {
    return _c('div', {
      attrs: {
        "index": ""
      }
    }, [_c('div', {
      staticClass: "zbxxtitle"
    }, [_c('div', {
      staticClass: "zbxxname"
    }, [_c('div', [_vm._v(_vm._s(zbxxclass.sys_dname) + "\n                "), _c('span', [_vm._v(_vm._s(zbxxclass.sys_engname))])])]), _vm._v(" "), _c('div', {
      staticClass: "more",
      on: {
        "click": function($event) {
          return _vm.toMore(zbxxclass)
        }
      }
    }, [_vm._v("更多 MORE"), _c('span', [_vm._v(">")])])]), _vm._v(" "), _c('div', {
      staticClass: "zbxxcontent"
    }, _vm._l((zbxxclass.zbxx), function(item) {
      return _c('div', {
        staticClass: "product",
        on: {
          "click": function($event) {
            return _vm.toZbxxDetail(item)
          }
        }
      }, [_c('div', {
        staticClass: "jiantou"
      }, [_vm._v(" >")]), _vm._v(" "), _c('div', {
        staticClass: "p-value line-c",
        domProps: {
          "innerHTML": _vm._s(item.sys_title)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "datecontent"
      }, [_vm._v(_vm._s(item.sys_idate))])])
    }), 0)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "sidebar_b"
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('div', {
    staticClass: "btn-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn2",
    on: {
      "click": function($event) {
        return _vm.toOutLink(2)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "btn3",
    on: {
      "click": function($event) {
        return _vm.toOutLink(3)
      }
    }
  }, [_vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "left-title"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.sysparam.homesectitle6 ? _vm.sysparam.homesectitle6.sysparambeg : '') + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.sysparam.homesectitle6 ? _vm.sysparam.homesectitle6.sysparamend : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.rigthToMore(_vm.sysparam.homesectitle6 ? _vm.sysparam.homesectitle6.sysparambeg : '')
      }
    }
  }, [_vm._v("\n              更多"), _c('span', [_vm._v(">")])])]), _vm._v(" "), _c('div', {
    staticClass: "yjlist"
  }, _vm._l((_vm.xzlist), function(item, index) {
    return _c('div', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.downF(item)
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "point"
    }), _vm._v(" "), _c('li', [_vm._v(_vm._s(item.operwcontitle))])])])
  }), 0)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "left-title"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.sysparam.homesectitle2 ? _vm.sysparam.homesectitle2.sysparambeg : '') + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.sysparam.homesectitle2 ? _vm.sysparam.homesectitle2.sysparamend : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.rigthToMore(_vm.sysparam.homesectitle2 ? _vm.sysparam.homesectitle2.sysparambeg : '')
      }
    }
  }, [_vm._v("\n              更多"), _c('span', [_vm._v(">")])])]), _vm._v(" "), _c('div', {
    staticClass: "news"
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "wraper b-d-b",
      attrs: {
        "flex": "dir:left box:first"
      },
      on: {
        "click": function($event) {
          return _vm.Link(item)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "width": "73px",
        "height": "75px",
        "cursor": "pointer",
        "background-color": "#F6F6F6",
        "margin-right": "10px"
      }
    }, [_c('div', {
      staticClass: "a-c",
      staticStyle: {
        "font-size": "30px",
        "color": "#f69806"
      }
    }, [_vm._v(_vm._s(_vm._f("shortDate2")(item.createtime)))]), _vm._v(" "), _c('span', {
      staticClass: "a-c",
      staticStyle: {
        "color": "#020202"
      }
    }, [_vm._v(_vm._s(_vm._f("shortDate")(item.createtime)))])]), _vm._v(" "), _c('div', [_c('h4', {
      staticStyle: {
        "padding-top": "5px",
        "cursor": "pointer",
        "display": "-webkit-box",
        "-webkit-line-clamp": "1",
        "-webkit-box-orient": "vertical",
        "overflow": "hidden"
      }
    }, [_vm._v(_vm._s(_vm._f("filter2")(item.operwcontitle)))]), _vm._v(" "), _c('p', {
      staticClass: "f_12",
      staticStyle: {
        "display": "-webkit-box",
        "-webkit-line-clamp": "2",
        "-webkit-box-orient": "vertical",
        "overflow": "hidden",
        "line-height": "18px",
        "color": "#666",
        "padding-top": "5px",
        "cursor": "pointer"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm._f("filter")(item.operwcondesc)))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "left-title"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.sysparam.homesectitle4 ? _vm.sysparam.homesectitle4.sysparambeg : ''))]), _vm._v(" "), _c('div', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.sysparam.homesectitle4 ? _vm.sysparam.homesectitle4.sysparamend : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.rigthToMore(_vm.sysparam.homesectitle4 ? _vm.sysparam.homesectitle4.sysparambeg : '')
      }
    }
  }, [_vm._v("\n            更多"), _c('span', [_vm._v(">")])])]), _vm._v(" "), _c('div', {
    staticClass: "contactus"
  }, [_c('div', [_vm._v("地址：" + _vm._s(_vm.sysparam.address ? _vm.sysparam.address.sysparambeg : ''))]), _vm._v(" "), _c('div', [_vm._v("热线：" + _vm._s(_vm.sysparam.hottel ? _vm.sysparam.hottel.sysparambeg : ''))]), _vm._v(" "), _c('div', [_vm._v("总机：" + _vm._s(_vm.sysparam.generalnumber ? _vm.sysparam.generalnumber.sysparambeg : ''))]), _vm._v(" "), _c('div', [_vm._v("传真：" + _vm._s(_vm.sysparam.fax ? _vm.sysparam.fax.sysparambeg : ''))]), _vm._v(" "), _c('div', [_vm._v("邮箱：" + _vm._s(_vm.sysparam.email ? _vm.sysparam.email.sysparambeg : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "left-title"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.sysparam.homesectitle5 ? _vm.sysparam.homesectitle5.sysparambeg : ''))]), _vm._v(" "), _c('div', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.sysparam.homesectitle5 ? _vm.sysparam.homesectitle5.sysparamend : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.rigthToMore(_vm.sysparam.homesectitle5 ? _vm.sysparam.homesectitle5.sysparambeg : '')
      }
    }
  }, [_vm._v("\n            更多"), _c('span', [_vm._v(">")])])]), _vm._v(" "), _c('div', {
    staticClass: "yjlist"
  }, _vm._l((_vm.yjlist), function(item, index) {
    return _c('div', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.Link(item)
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "point"
    }), _vm._v(" "), _c('li', [_vm._v(_vm._s(item.operwcontitle))])])])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn1",
    staticStyle: {
      "cursor": "not-allowed"
    }
  }, [_c('div', {
    staticClass: "btnleft"
  }, [_c('i'), _vm._v("专家入库"), _c('span', [_vm._v("Expert")])]), _vm._v(" "), _c('div', {
    staticClass: "btnright"
  }, [_c('div', [_vm._v("---")]), _vm._v(" "), _c('div', [_vm._v(">>>")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btnleft"
  }, [_c('i'), _vm._v("投标人注册"), _c('span', [_vm._v("Bidder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btnright"
  }, [_c('div', [_vm._v("---")]), _vm._v(" "), _c('div', [_vm._v(">>>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btnleft"
  }, [_c('i'), _vm._v("招标人注册"), _c('span', [_vm._v("Biddee")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btnright"
  }, [_c('div', [_vm._v("---")]), _vm._v(" "), _c('div', [_vm._v(">>>")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-134d781a!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeTemplate/templateA.vue
// module id = 294
// module chunks = 0